export default __webpack_public_path__ + "static/media/BP-logo_and_big_website_black.3f4e9e06.jpg";